import PropTypes from 'prop-types';
import Radio from '../Inputs/Radio';

const propTypes = {
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    listItems: PropTypes.array,
};

const RadioButtonLarge = ({ onClick, value, selectedValue, title, classes, listItems = [] }) => {
    return (
        <div className={'cursor-pointer'} onClick={() => onClick(value)}>
            <div className={'flex items-center mt-4 mb-2'}>
                <Radio checked={value === selectedValue} />
                <p className={'text-[1.1rem] font-normal leading-normal m-0'}>
                    <b>{ title }</b>
                </p>
            </div>
            <ul className={'m-0 sm:my-0 pl-2 sm:pl-16'}>
                {
                    listItems &&
                    listItems.map(point =>
                        <li
                            className={'text-[1.1rem] font-normal leading-normal m-0 list-item cursor-pointer'}
                            key={point}
                            dangerouslySetInnerHTML={{ __html: point }}
                        />
                    )
                }
            </ul>
        </div>
    );
};

RadioButtonLarge.propTypes = propTypes;

export default RadioButtonLarge;
